import Image from "next/image"
import { memo, ReactEventHandler } from "react"
import styled from "styled-components"

// export const blurUrl =
//   "data:image/png;base64,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"

// const maxImageSize = 1200

const StyledImageContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`

const getSizes = (size: string[] | string | null) => {
  if (!size) return null
  let sizes: string
  switch (typeof size) {
    case "string":
      sizes = size
      break
    default:
      sizes =
        size?.length > 1 ? `(min-width: 768px) ${size[1]}, ${size[0]}` : size[0]
  }
  return sizes
}

type NextImageProps = {
  image: { imageUrl: string; alt: string; icon?: string; text?: string }
  /**
   * Represents the size of the image in the screen width in vw or in px
   * if Array, first value for mobile and second value desktop
   *
   */
  imageSizes?: string[] | string
  cover?: boolean
  priority?: boolean
  onLoadCallBack?: ReactEventHandler<HTMLImageElement>
  onLoadingComplete?: () => void
  loadingEager?: boolean
  unoptimized?: boolean
  noLazyBoundry?: boolean
  role?: string
  ariaHidden?: boolean
  objectPosition?:
    | "center"
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "top left"
    | "top right"
    | "bottom left"
    | "bottom right"
    | "center left"
    | "center right"
    | "center top"
    | "center bottom"
} & React.HTMLProps<HTMLImageElement>

const NextImage = ({
  image,
  imageSizes,
  cover = true,
  className,
  priority = false,
  onLoadCallBack,
  onLoadingComplete,
  loadingEager = false,
  unoptimized,
  noLazyBoundry,
  role,
  ariaHidden,
  objectPosition,
}: NextImageProps) => {
  const objectFit = cover ? "cover" : "contain"

  return (
    <StyledImageContainer>
      <Image
        src={image?.imageUrl}
        sizes={getSizes(imageSizes)}
        alt={image?.alt || ""}
        className={className}
        layout="fill"
        objectFit={objectFit}
        priority={priority}
        onLoad={onLoadCallBack}
        loading={loadingEager ? "eager" : undefined}
        onLoadingComplete={onLoadingComplete}
        // placeholder="blur"
        // blurDataURL={blurUrl}
        // no lazy loading for now
        unoptimized={unoptimized}
        lazyBoundary={noLazyBoundry ? null : "800px"}
        role={role}
        aria-hidden={ariaHidden}
        objectPosition={objectPosition}
      />
    </StyledImageContainer>
  )
}

export default memo(NextImage)
